<a
  class="re-standalone re-focus-keydown"
  href="#"
  (click)="openLob()"
  (keydown.enter)="openLob()"
  >{{ label }}</a
>
